import * as React from "react"
const ArrowRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#202327"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.333 8H2.667M10 11.333S13.334 8.878 13.334 8C13.334 7.12 10 4.667 10 4.667"
    />
  </svg>
)
export default ArrowRight
